import React from 'react';
import styled from 'styled-components';

export const Radio = ({ name, children, ...rest }) => (
  <RadioWrapper>
    <Label>
      <Input {...rest} name={name} type="radio" />
      <Mark />
      {children}
    </Label>
  </RadioWrapper>
);

const RadioWrapper = styled.div`
  display: inline-block;
  flex-grow: 1;
`;

const Mark = styled.span`
  display: inline-block;
  position: relative;
  box-shadow: ${({ boxShadow = 'bottom', theme }) => theme.shadows[boxShadow] || boxShadow};
  width: 20px;
  height: 20px;
  left: 0;
  border-radius: 50%;
  margin-right: 10px;
  vertical-align: middle;
  &::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.primary};
    opacity: 0;
    left: 50%;
    top: 50%;
    position: absolute;
    transition: all 110ms;
  }
`;

const Input = styled.input`
  position: absolute;
  visibility: hidden;
  display: none;
  &:checked + ${Mark} {
    &::after {
      width: 12px;
      height: 12px;
      opacity: 1;
      left: 4px;
      top: 4px;
    }
  }
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 10px 5px 0;
  position: relative;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colors.grey};
  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
    opacity: 0.4;
  `}
`;
